import { render } from "./solidgauge.vue?vue&type=template&id=bf7f0a1c&scoped=true"
import script from "./solidgauge.vue?vue&type=script&lang=js"
export * from "./solidgauge.vue?vue&type=script&lang=js"

import "./solidgauge.vue?vue&type=style&index=0&id=bf7f0a1c&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf7f0a1c"]])

export default __exports__